import ReactGA from "react-ga";

const __ga_code = process.env.REACT_APP_GOOGLE_ANALYTICS_CODE;

let loaded = 0;

// Only debug when in development
const debug = process.env.NODE_ENV === "development" ? 0 : 0;

export const setGoogleAnalyticsEnvironment = function() {
	if (!__ga_code || __ga_code === "" || loaded) return;

	// Initialize Google Analytics
	if (debug) console.log("initialize", __ga_code);
	ReactGA.initialize(__ga_code);

	// Require ecommerce plugin
	ReactGA.plugin.require("ec");

	// Set first page view
	// if (page !== "") {
	// 	if (debug) console.log("pageview", page);
	// 	ReactGA.ga("send", "pageview", page);
	// }

	// Ensure app knows GA is loaded
	loaded++;
};



// WEBPACK FOOTER //
// ./src/utils/google-analytics.js